import React,{ Component } from 'react';
import {Input } from 'semantic-ui-react';
import '../style/DraggablePanel.css';

//import CSImage from '../image/cs-roof.jpg'
//import tileImage from '../image/tile-roof.png'
//import metalImage from '../image/metal-roof.png'
//import DIYImage from '../image/diy-roof.png'


//const mountOptions = [
//    {
//        key: 'Composite Shingle',
//        text: 'Composite Shingle',
//        value: 'Composite Shingle',
//        image: { avatar: true, src: CSImage },
//    },
//    {
//        key: 'Tile',
//        text: 'Tile',
//        value: 'Tile',
//        image: { avatar: true, src: tileImage },
//    },
//    {
//        key: 'Metal',
//        text: 'Metal',
//        value: 'Metal',
//        image: { avatar: true, src: metalImage },
//    },
//    {
//        key: 'DIY',
//        text: 'DIY',
//        value: 'DIY',
//        image: { avatar: true, src: DIYImage },
//    },
//
//];

class PanelDetail extends Component {

    constructor(props){
        super(props);
        this.state={
            panelnumber : this.props.panelnumber,
            rotation: localStorage.getItem('rotation'+this.props.panelnumber) ? localStorage.getItem('rotation'+this.props.panelnumber) : 0,
            inclination: localStorage.getItem('inclination'+this.props.panelnumber) ? localStorage.getItem('inclination'+this.props.panelnumber) : 0,
            mountType: localStorage.getItem('mountType'+this.props.panelnumber) ? localStorage.getItem('mountType'+this.props.panelnumber) : null,
        }
        this.RotationChange = this.RotationChange.bind(this);
        this.InclinationChange = this.InclinationChange.bind(this);
        this.MountChange = this.MountChange.bind(this);
    }

    componentDidMount(){
        if(localStorage.getItem("ACPower"+this.props.panelnumber) === null){
            localStorage.setItem("ACPower"+this.props.panelnumber,'120VAC');
        }
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.panelnumber !== this.props.panelnumber) {
        this.setState({
          panelnumber : nextProps.panelnumber,
          rotation: localStorage.getItem('rotation'+nextProps.panelnumber) ? localStorage.getItem('rotation'+nextProps.panelnumber) : 0,
          inclination: localStorage.getItem('inclination'+nextProps.panelnumber) ? localStorage.getItem('inclination'+nextProps.panelnumber) : 0,
          mountType: localStorage.getItem('mountType'+nextProps.panelnumber) ? localStorage.getItem('mountType'+nextProps.panelnumber) : null,
        });
      }
    }

    RotationChange(rotationData){
        this.setState({
            rotation : rotationData
        })
        localStorage.setItem("rotation"+this.props.panelnumber,rotationData);
      this.props.onRotationChange(rotationData);
    }
    InclinationChange(inclinationData){
        this.setState({
            inclination : inclinationData
        })
        localStorage.setItem("inclination"+this.props.panelnumber,inclinationData);
      this.props.onInclinationChange(inclinationData);
    }

    MountChange(event,data){
        this.setState({
            mountType: data.value
        })
        localStorage.setItem("mountType"+this.props.panelnumber,data.value);
       this.props.transeMountType(data.value);
    };


    render (){
            return(
                <div className='inputArea'>
                  <div className="row input-wrapper">
                    <div className="col-lg-12 col-md-12 header"><label>Step 3.</label> Rotation &deg;Deg</div>
                    <div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-12 text-center">
                      <Input
                        size='mini'
                        type='text'
                        placeholder='Enter Degree'
                        value={this.state.rotation}
                        onChange={e => this.RotationChange(e.target.value)}
                      />
                    </div>

                  </div>

                  <div className="row input-wrapper">
                    <div className="col-lg-12 col-md-12 header">Inclination &deg;Deg</div>
                    <div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-12 text-center">
                      <Input
                        placeholder='Enter Degree'
                        value={this.state.inclination}
                        size='mini'
                        onChange={e => this.InclinationChange(e.target.value)}
                      />

                    </div>
                  </div>

                  {/*<div className="row input-wrapper">
                    <div className="col-lg-3 col-md-3 header">Mount Type</div>
                    <div className="col-lg-5 col-md-5">
                      <Dropdown
                          placeholder='Select Type'
                          selection options={mountOptions}
                          value={this.state.mountType}
                          onChange ={(e,data) => this.MountChange(e,data)}
                        />
                    </div>
                  </div>*/}

                </div>
            )
        }
    }

export default PanelDetail;



// WEBPACK FOOTER //
// ./src/components/PanelDetail.js